import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private _loading = new BehaviorSubject<boolean>(false); // API loader
  public loading$ = this._loading.asObservable();

  // private _pageLoading = new BehaviorSubject<boolean>(false); // Page loader
  // public pageLoader$ = this._pageLoading.asObservable();

  // Check if any loader is already active
  private isAnyLoaderActive(): boolean {
    return this._loading.getValue()
    //  || 
    // this._pageLoading.getValue();
  }

  // API Loader Methods
  show() {
    if (!this.isAnyLoaderActive()) {
      this._loading.next(true);
    }
  }

  hide() {
      if (this._loading.getValue()) {
        this._loading.next(false);
      }
  }

  // Page Loader Methods
  // showPageLoader() {
  //   if (!this.isAnyLoaderActive()) {
  //     this._pageLoading.next(true);
  //   }
  // }

  // hidePageLoader() {
  //   setTimeout(() => {
  //     if (this._pageLoading.getValue()) {
  //       this._pageLoading.next(false);
  //     }
  //   }, 100);
  // }
}
